import type { Currency } from '../../../../shared/lib/currency';

export const maximumLogoPriceFromFaqsInCents: Record<Currency, number> = {
    AUD: 2000000,
    CAD: 2000000,
    CHF: 1000000,
    DKK: 10000000,
    EUR: 1000000,
    GBP: 1000000,
    HKD: 10000000,
    JPY: 1400000,
    MXN: 3000000,
    NOK: 10000000,
    SGD: 2000000,
    USD: 1000000,
};

export const logoBronzeContestPriceInCents: Record<Currency, number> = {
    AUD: 39900,
    CAD: 39900,
    CHF: 30900,
    DKK: 199900,
    EUR: 26900,
    GBP: 23900,
    HKD: 239900,
    JPY: 32199,
    MXN: 569900,
    NOK: 259900,
    SGD: 42900,
    USD: 24900,
};

export const logoPlatinumContestPriceInCents: Record<Currency, number> = {
    AUD: 179900,
    CAD: 169900,
    CHF: 139900,
    DKK: 879900,
    EUR: 119900,
    GBP: 99900,
    HKD: 1049900,
    JPY: 139999,
    MXN: 2469900,
    NOK: 1139900,
    SGD: 189900,
    USD: 105000,
};

export const logoBusinessCardPriceInCents: Record<Currency, number> = {
    AUD: 59900,
    CAD: 59900,
    CHF: 45900,
    DKK: 299900,
    EUR: 40900,
    GBP: 35900,
    HKD: 359900,
    JPY: 48399,
    MXN: 849900,
    NOK: 389900,
    SGD: 63900,
    USD: 44900,
};

export const logoBusinessCardSavingsInCents: Record<Currency, number> = {
    AUD: 6900,
    CAD: 6900,
    CHF: 5900,
    DKK: 39900,
    EUR: 3900,
    GBP: 3900,
    HKD: 39900,
    JPY: 5199,
    MXN: 99900,
    NOK: 49900,
    SGD: 6900,
    USD: 4900,
};

export const logoBrandIdentityPriceInCents: Record<Currency, number> = {
    AUD: 79900,
    CAD: 79900,
    CHF: 61900,
    DKK: 409900,
    EUR: 54900,
    GBP: 46900,
    HKD: 489900,
    JPY: 64499,
    MXN: 1139900,
    NOK: 529900,
    SGD: 84900,
    USD: 59900,
};

export const logoBrandIdentityPercentageSavings: Record<Currency, number> = {
    AUD: 39,
    CAD: 39,
    CHF: 39,
    DKK: 39,
    EUR: 37,
    GBP: 39,
    HKD: 37,
    JPY: 39,
    MXN: 39,
    NOK: 39,
    SGD: 38,
    USD: 39,
};

// We only offer the logo-web-bundle in USD
export const logoWebPriceInCents: Record<'USD', number> = {
    USD: 139900,
};

export const logoWebSavingsInCents: Record<'USD', number> = {
    USD: 30000,
};
